import type { OptionType } from "../types/types";

export const sortOptionsByLabel = (
  options: OptionType<string>[]
): OptionType<string>[] =>
  [...options].sort((a, b) => a.label.localeCompare(b.label));
